module.exports = function limitNumber(val, min, max) {
	return Math.max(min, Math.min(max, val));
}